function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import RESTAdapter from '@ember-data/adapter/rest';
import { apiHost } from '@square/environment-utils/api-urls';
// eslint-disable-next-line dashboard/use-utilities-window
import window from 'ember-window-mock';
export function getChannelsHost() {
  const protocol = new URL(window.location.origin).protocol;
  return `${protocol}//${apiHost(window.location.host)}`;
}
export const channelsHost = getChannelsHost();
export default class BaseChannel extends RESTAdapter {
  constructor(arg) {
    super(arg);
    _defineProperty(this, "useFetch", void 0);
    _defineProperty(this, "host", channelsHost);
    this.useFetch = false;
  }
  ajaxOptions(url, method, options) {
    // We need to set this for CORS requests
    // eslint-disable-next-line no-param-reassign
    options.xhrFields = {
      withCredentials: true
    };
    return super.ajaxOptions(url, method, options);
  }
}